export default {
      id: "arrowDown-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#arrowDown-usage",
      toString: function () {
        return this.url;
      }
    }